import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, fmt } from "@/lib/api";

export default function TradeDialog({ open, onOpenChange, preset, onDone }) {
  const [form, setForm] = useState(null);
  const f = form || {
    symbol: preset?.symbol || "EUR/USD", direction: preset?.direction || "BUY", lots: 0.1,
    stop_loss: preset?.stop_loss ?? "", take_profit: preset?.tp1 ?? "",
  };
  const set = (k, v) => setForm({ ...f, [k]: v });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/paper/trades", {
        symbol: f.symbol, direction: f.direction, lots: Number(f.lots),
        stop_loss: f.stop_loss === "" ? null : Number(f.stop_loss), take_profit: f.take_profit === "" ? null : Number(f.take_profit),
        signal_id: preset?.signal_id || null, confidence: preset?.confidence ?? null,
      });
      toast.success(`Paper ${f.direction} ${f.symbol} opened`);
      setForm(null);
      onOpenChange(false);
      onDone && onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const inp = "w-full bg-white border border-zinc-200 rounded-sm px-3 py-2 num text-sm text-zinc-900 focus:outline-none focus:border-[#007AFF]";
  return (
    <Dialog open={open} onOpenChange={(o) => { setForm(null); onOpenChange(o); }}>
      <DialogContent className="bg-white border-zinc-200 rounded-sm max-w-md" data-testid="trade-dialog">
        <DialogHeader><DialogTitle className="font-display">Open Paper Trade · {f.symbol}</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500 -mt-2">Virtual funds only. Executes at the current market {f.direction === "BUY" ? "ask" : "bid"} price{preset?.entry ? ` (signal entry ${fmt(preset.entry, preset.digits)})` : ""}.</p>
        <div className="grid grid-cols-2 gap-2">
          {["BUY", "SELL"].map((d) => (
            <button key={d} onClick={() => set("direction", d)} data-testid={`trade-direction-${d.toLowerCase()}`}
              className={`py-2 text-sm font-bold rounded-sm border transition-colors ${f.direction === d ? (d === "BUY" ? "bg-[#059669] text-white border-[#059669]" : "bg-[#DC2626] border-[#DC2626] text-white") : "border-zinc-200 text-zinc-500 hover:border-zinc-400"}`}>
              {d}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-3">
          <label className="space-y-1"><span className="label-xs">Lots</span>
            <input className={inp} type="number" step="0.01" value={f.lots} onChange={(e) => set("lots", e.target.value)} data-testid="trade-lots-input" /></label>
          <label className="space-y-1"><span className="label-xs">Stop Loss</span>
            <input className={inp} type="number" step="any" value={f.stop_loss} onChange={(e) => set("stop_loss", e.target.value)} data-testid="trade-sl-input" /></label>
          <label className="space-y-1"><span className="label-xs">Take Profit</span>
            <input className={inp} type="number" step="any" value={f.take_profit} onChange={(e) => set("take_profit", e.target.value)} data-testid="trade-tp-input" /></label>
        </div>
        <button disabled={busy} onClick={submit} data-testid="trade-submit-btn"
          className="w-full py-2.5 bg-[#007AFF] hover:bg-[#1a86ff] active:scale-[0.99] transition-[background-color,transform] text-sm font-semibold rounded-sm disabled:opacity-50 text-white">
          {busy ? "Opening…" : "Confirm Paper Trade"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
